import React from "react";
import './AboutStaff.css';
import Hugo from "../img/Hugo.PNG";

const AboutStaff = () => {
    return (
        <div id="about_staff">
            <section className="section-staff">
                <figure className="img_about1">
                    <img src={Hugo} alt="Mestre Hugo Matos" className="hugo2" />
                    <figcaption>Mestre Hugo Matos</figcaption>
                </figure>
                <div className="about-hugo">
                    <h1 className="page-title">Biografia</h1>
                    <p>
                        Hugo Matos, nascido a 26 de fevereiro de 1974, iniciou-se cedo no fantástico mundo do kickboxing e cedo
                        percebeu que esta era a sua vocação e o mundo para o qual tinha nascido. Sempre lutou e trabalhou em prol
                        do desporto, procurando elevá-lo ao mais alto nível.
                    </p>
                    <p>O Mestre Hugo Matos é o fundador e Mestre de todas as Escolas de Kickboxing HM.</p>

                    <h2>Títulos</h2>
                    <p>
                        Atual Campeão Nacional de Profissionais de Full Contact, possuidor de 14 títulos nacionais de amadores em
                        Light Contact, Semi-Contact e Full Contact, 2 títulos ibéricos, vencedor de 3 medalhas de bronze consecutivas
                        em Campeonatos do Mundo e da Europa, e distinguido em várias ocasiões como melhor atleta do ano pela mesma federação.
                    </p>
                    <p>
                        Já ocupou o 4.º lugar no ranking mundial da maior federação deste desporto a nível mundial:
                        WAKO — World Association of Kickboxing Organizations.
                    </p>

                    <h2>Competências</h2>
                    <p>
                        Possui todas as capacidades técnicas e psicológicas que fazem dele um dos melhores treinadores da atualidade.
                        Detém o grau de 3.º Dan de Kickboxing e o grau de 1.º Dan de Taekwondo.
                        Tem todas as qualidades desportivas e humanas para fazer de qualquer aluno um verdadeiro campeão.
                    </p>
                </div>
            </section>
        </div>
    );
};

export default AboutStaff;
